<template>
    <Grid class="users-repeater-item" :gap-y="10">
        <Column>
            <FormField
                v-if="schema.email"
                name="user.email"
                :label="schema.email.label"
                :required="schema.email.required"
                :error="error"
            >
                <FormInput
                    ref="userEmailRes"
                    v-model="localUser.email"
                    type="email"
                    :placeholder="schema.email.label"
                />
            </FormField>
            <FormField
                v-if="schema.languages"
                name="user.languages"
                :label="schema.languages.label"
                :required="schema.languages.required"
                :error="error"
            >
                <MultiSelect
                    v-model="localUser.languages"
                    :options="languages"
                    :form-value-text="(item) => item.label"
                    emit-prop="id"
                    with-filter
                    paginate
                    width="100%"
                >
                    <template #default="{ item }">
                        {{ item.label }}
                    </template>
                </MultiSelect>
            </FormField>
        </Column>
        <Column v-if="schema.roles">
            <FormField
                name="user.roles"
                :label="schema.roles.label"
                :error="error"
                class="users-repeater-item__roles"
            >
                <Checkbox
                    v-for="role in schema.roles.choices"
                    :key="role.value"
                    v-model="localUser.roles"
                    :value="role.value"
                >
                    {{ role.display_name }}
                </Checkbox>
            </FormField>
        </Column>
        <Column v-if="canDelete">
            <button
                v-tooltip.left="$t('misc.delete')"
                type="button"
                class="button users-repeater-item__delete"
                @click.prevent="$emit('deleteUser')"
            >
                <IconCross />
            </button>
        </Column>
    </Grid>
</template>

<script>
import { Checkbox, FormField, FormInput, MultiSelect } from '@speechki-frontend/shared/ui/forms';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { IconCross } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'UsersRepeaterItem',
    components: {
        Checkbox,
        FormField,
        FormInput,
        MultiSelect,
        Grid,
        Column,
        IconCross,
    },
    inject: ['languages'],
    props: {
        schema: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Object,
            required: true,
        },
        error: {
            type: Object,
            default: () => ({}),
        },
        canDelete: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'deleteUser'],
    data() {
        return {
            localUser: { ...this.modelValue },
        };
    },
    watch: {
        modelValue(val) {
            this.localUser = { ...val };
        },
        localUser: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', val);
            },
        },
    },
    mounted() {
        const { userEmailRes } = this.$refs;
        if (userEmailRes) userEmailRes.focus();
    },
};
</script>

<style src="./UsersRepeaterItem.scss" lang="scss"></style>
